<template>
  <div
    class="navbar-container"
    :class="{
      'dropdown-showing': profileDropdownShowing || navbarDrawerShowing,
    }"
  >
    <nav class="navbar">
      <img
        class="menu"
        src="../../assets/images/icons/menu.svg"
        @click="setNavbarDrawerShowing(true)"
      />
      <router-link
        :to="{
          name: this.getUser ? ROUTER_NAMES.DASHBOARD : ROUTER_NAMES.HOME,
        }"
        class="logo"
      >
        <img src="@/assets/images/icons/logo.svg" alt="logo" />
      </router-link>
      <GameSelect class="hide-on-small" />
      <NavLinks class="hide-on-small" />
      <CoachingContainer class="hide-on-small" />
      <StoreContainer class="hide-on-small" v-if="getUser" />
      <Profile class="hide-on-small" v-if="getUser" />
      <a href="/login" v-if="!getUser" class="login">LOGIN</a>
    </nav>
    <transition name="slide-fade">
      <GameContainer v-if="showGameContainer" />
    </transition>
    <transition name="slide-fade">
      <navbar-drawer v-if="navbarDrawerShowing" />
    </transition>
    <transition name="slide-fade">
      <profile-dropdown v-if="profileDropdownShowing" />
    </transition>
  </div>
</template>

<script>
import { ROUTER_NAMES } from "@/constants/router.constants"
import { mapActions, mapGetters, mapMutations } from "vuex"
import GameSelect from "./game/GameSelect"
import NavLinks from "./NavLinks"
import CoachingContainer from "./CoachingContainer"
import StoreContainer from "./StoreContainer"
import GemContainer from "./GemContainer"
import Profile from "./Profile"
import GameContainer from "./game/GameContainer"

export default {
  components: {
    GameSelect,
    NavLinks,
    CoachingContainer,
    StoreContainer,
    GemContainer,
    Profile,
    GameContainer,
    NavbarDrawer: () => import("./NavbarDrawer"),
    ProfileDropdown: () => import("./ProfileDropdown"),
  },
  computed: {
    ...mapGetters("Util", ["showGameContainer", "navbarDrawerShowing"]),
    ...mapGetters("Util", ["profileDropdownShowing"]),
    ...mapGetters("User", ["getUser"]),
  },
  methods: {
    ...mapActions("User/Coaching", [
      "loadInstaProAccessToken",
      "loadInstaProUser",
    ]),
    ...mapActions("User/Profile", ["loadSettings"]),
    ...mapActions("User", [
      "loadUserActiveGames",
      "loadUser",
      "loadUserCapabilities",
    ]),
    ...mapActions("Game", ["fetchPgGames"]),
    ...mapMutations("Util", ["setNavbarDrawerShowing"]),
  },
  async created () {
    this.ROUTER_NAMES = ROUTER_NAMES
    const userAccessToken = window.localStorage.getItem("client_credentials")
    const userRefreshToken = window.localStorage.getItem("refresh_token")
    if (!this.$_.isEmpty(userAccessToken) || !this.$_.isEmpty(userRefreshToken)) {
      await this.loadUser()
      await this.loadInstaProAccessToken()
      this.loadInstaProUser()
      this.loadSettings()
      this.loadUserActiveGames()
      this.loadUserCapabilities()
    }
    this.fetchPgGames()
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
@import "@/assets/style/_variables.scss";
.navbar-container {
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 9;
  &.dropdown-showing {
    z-index: 11;
  }
  .navbar {
    height: $nav-bar-height;
    background: #18181b;
    display: flex;
    align-items: center;
    @include desktop-down {
      padding: 0 2rem;
      justify-content: space-between;
    }
    .menu {
      display: none;
      width: 2.75rem;
      cursor: pointer;
      @include desktop-down {
        display: block;
      }
    }
    .logo {
      width: 30px;
      display: block;
      margin: 0 3rem;
      @include desktop-down {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        margin: 0;
      }
    }
    .hide-on-small {
      @include desktop-down {
        display: none;
      }
    }
    .login {
      text-decoration: none;
      margin-left: auto;
      margin-right: 3rem;
      width: 9.5rem;
      height: 3.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      color: #141417;
      font-size: 1.5rem;
      line-height: 110%;
      font-weight: 700;
      font-family: $font-display;
      border-radius: 4px;
      &:hover {
        background: rgb(219, 219, 219);
      }
      @include desktop-down {
        margin-right: 0;
      }
    }
  }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: scaleY(0);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/Navbar.vue